import styles from "./CustomizedTreatmentCard.module.css";

const CustomizedTreatmentCard = () => {
  return (
    <div className={styles.testimonial}>
      <div className={styles.frameParent}>
        <div className={styles.frameGroup}>
          <div className={styles.oneOnOneCustomizedTreatmenParent}>
            <b className={styles.oneOnOneContainer}>
              <p className={styles.oneOnOne}>{`One on One Customized `}</p>
              <p className={styles.oneOnOne}>Treatment</p>
            </b>
            <div className={styles.youAreNotContainer}>
              <p className={styles.youAreNot}>
                You are not alone! We are here to help you get back on your
                feet.  
              </p>
              <p className={styles.oneOnOne}>&nbsp;</p>
            </div>
          </div>
          <div className={styles.frameContainer}>
            <button className={styles.bookAppointmentWrapper}>
              <div className={styles.bookAppointment}>Book Appointment</div>
            </button>
            <button className={styles.freeConsultWrapper}>
              <div className={styles.freeConsult}>{`Free Consult `}</div>
            </button>
          </div>
        </div>
        <img className={styles.frameChild} alt="" src="/group-13.svg" />
      </div>
    </div>
  );
};

export default CustomizedTreatmentCard;
